import Vue from 'vue';
import Router from 'vue-router';

// Import the components
import Dibble from '../components/Dibble'
import Welcome from "@/components/Welcome/Welcome";
import ThankyouPage from '@/components/ThankYou/Thankyou.vue'
import SorryPage from '@/components/Sorry/Sorry.vue'
import DonatePage from '@/components/Donate/Donate.vue'
import WallPage from '@/components/Wall/Wall.vue'
import {PATH} from '@/constant/Path.js'
import Request from "@/components/Request/Request.vue";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: definedRoutes()
});

function definedRoutes() {
    return [
        {
            path: '/',
            name: 'Home',
            component: Dibble,
            meta: {
                showHeader: true
            }
        },
        {
            path: PATH.WELCOME_WITHOUT_ID,
            name: 'Welcome',
            component: Welcome,
            meta: {
                showHeader: true
            }
        },
        {
            path: PATH.WELCOME,
            name: 'Welcome',
            component: Welcome,
            meta: {
                showHeader: true
            }
        },
        {
            path: PATH.THANK_YOU,
            name: 'Thankyou',
            component: ThankyouPage,
            meta: {
                showHeader: true
            }
        },
        {
            path: PATH.SORRY,
            name: 'Sorry',
            component: SorryPage,
            meta: {
                showHeader: true
            }
        },
        {
            path: PATH.DONATE,
            name: 'Donate',
            component: DonatePage,
            meta: {
                showHeader: true
            }
        },
        {
            path: PATH.WALL,
            name: 'Wall',
            component: WallPage
        },
        {
            path: PATH.REQUEST,
            name: 'Request',
            component: Request
        }
    ];
}

export default router;
